"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _Icon = _interopRequireDefault(require("../Icon"));

var _device = require("../../toolkit/device");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e) { function e(_x) { return _e.apply(this, arguments); } e.toString = function () { return _e.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e2) { function e(_x2) { return _e2.apply(this, arguments); } e.toString = function () { return _e2.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var demoProps = {
  value: 100000,
  onChange: function onChange() {},
  incrementStep: 1
}; // String are not used for users, just documentation.

/* eslint-disable local-rules/unwrapped-i18n */

var propDoc = {
  value: {
    required: true,
    type: "?number",
    description: "Current value to display"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the input is disabled. Set to true when " + "submitting a data to API"
  },
  onChange: {
    required: true,
    defaultValue: "null",
    type: "(args: {\n      valueAsNumber: null | undefined | number,\n      valueAsString: string\n    }) => mixed",
    description: "Callback for when the input value changes"
  },
  incrementStep: {
    required: false,
    defaultValue: "null",
    type: "number",
    description: "Allow the user to click a button to increment or decrement" + " the value. This value is the amount the value is" + " increment/decremented by each time"
  },
  numberFormat: {
    required: false,
    defaultValue: "'0,0'",
    type: "string",
    description: "Format in which to display the number. Values come from " + " [`numeraljs`](http://numeraljs.com/#format)"
  },
  onValidityChanged: {
    required: false,
    defaultValue: "null",
    type: "({isValid: boolean, errorMessage: (string | null)}) => mixed",
    description: "Callback for when the validity of the input changes"
  },
  focusOnMount: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Tells the input to acquire focus immediately after it loads"
  },
  forceValidation: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Turn on when the user clicks 'submit' on the form. Tells the text input to " + "validate the current input to see of form is ready for submission."
  },
  showValidationStatus: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Show error message from the validator when the input is invalid"
  }
};

var useNumericInputContext = function useNumericInputContext(props) {
  var onChange = props.onChange,
      value = props.value,
      disabled = props.disabled,
      incrementStep = props.incrementStep;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hasMadeChanges = _useState4[0],
      setHasMadeChanges = _useState4[1];

  var onInputChange = (0, _react.useCallback)(function (_ref) {
    var target = _ref.target;

    if (target instanceof HTMLInputElement) {
      var valueAsString = (target.value || "").replace(/,/g, "");
      var valueAsNumber = parseFloat(valueAsString);
      onChange({
        valueAsString: valueAsString,
        valueAsNumber: !isNaN(valueAsNumber) ? valueAsNumber : null
      });
      setInternalValue(valueAsString);
      setHasMadeChanges(true);
    }
  }, [setInternalValue, onChange]);
  var onUpClicked = (0, _react.useCallback)(function () {
    if (incrementStep == null) {
      return;
    }

    var valueAsNumber = incrementStep + (value !== null && value !== void 0 ? value : 0);
    var valueAsString = valueAsNumber.toString();
    onChange({
      valueAsString: valueAsString,
      valueAsNumber: valueAsNumber
    });
    setInternalValue(valueAsString);
    setHasMadeChanges(true);
  }, [incrementStep, value, setInternalValue, onChange]);
  var onDownClicked = (0, _react.useCallback)(function () {
    if (incrementStep == null) {
      return;
    }

    var valueAsNumber = (value !== null && value !== void 0 ? value : 0) - incrementStep;
    var valueAsString = valueAsNumber.toString();
    onChange({
      valueAsString: valueAsString,
      valueAsNumber: valueAsNumber
    });
    setInternalValue(valueAsString);
    setHasMadeChanges(true);
  }, [incrementStep, value, setInternalValue, onChange]);
  var inputValue = value != null ? value.toString() : internalValue;
  return _objectSpread(_objectSpread({}, props), {}, {
    inputValue: inputValue,
    onUpClicked: onUpClicked,
    onDownClicked: onDownClicked,
    onInputChange: onInputChange,
    incrementDisabled: disabled !== null && disabled !== void 0 ? disabled : false,
    decrementDisabled: disabled !== null && disabled !== void 0 ? disabled : false,
    hasMadeChanges: hasMadeChanges
  });
};

var NumericInput = function NumericInput(props) {
  var _useNumericInputConte = useNumericInputContext(props),
      style = _useNumericInputConte.style,
      className = _useNumericInputConte.className,
      inputValue = _useNumericInputConte.inputValue,
      onUpClicked = _useNumericInputConte.onUpClicked,
      onDownClicked = _useNumericInputConte.onDownClicked,
      incrementDisabled = _useNumericInputConte.incrementDisabled,
      decrementDisabled = _useNumericInputConte.decrementDisabled,
      value = _useNumericInputConte.value,
      disabled = _useNumericInputConte.disabled,
      onInputChange = _useNumericInputConte.onInputChange,
      incrementStep = _useNumericInputConte.incrementStep,
      validators = _useNumericInputConte.validators,
      onValidityChanged = _useNumericInputConte.onValidityChanged,
      focusOnMount = _useNumericInputConte.focusOnMount,
      forceValidation = _useNumericInputConte.forceValidation,
      hasMadeChanges = _useNumericInputConte.hasMadeChanges,
      _useNumericInputConte2 = _useNumericInputConte.showValidationStatus,
      showValidationStatus = _useNumericInputConte2 === void 0 ? true : _useNumericInputConte2;

  var placeholder = props.placeholder;
  var refContainer = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      validationResponse = _useState6[0],
      setValidationResponse = _useState6[1];

  var styles = useStylesheet(_objectSpread(_objectSpread({}, props), {}, {
    isValid: validationResponse == null
  }));
  (0, _react.useEffect)(function () {
    if (focusOnMount) {
      var current = refContainer.current;

      if (current != null) {
        current.focus();
      }
    }
  }, [focusOnMount]);
  (0, _react.useEffect)(function () {
    var validate = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var response, _iterator, _step, _value$toString, validator, vResponse;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                response = null;
                _iterator = _createForOfIteratorHelper(validators || []);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 12;
                  break;
                }

                validator = _step.value;
                _context.next = 8;
                return validator.validate((_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : "");

              case 8:
                vResponse = _context.sent;

                if (vResponse != null) {
                  response = vResponse;
                }

              case 10:
                _context.next = 4;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 17:
                _context.prev = 17;

                _iterator.f();

                return _context.finish(17);

              case 20:
                setValidationResponse(response);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 14, 17, 20]]);
      }));

      return function validate() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (hasMadeChanges || forceValidation) {
      validate();
    }
  }, [value, validators, hasMadeChanges, forceValidation]);
  (0, _react.useEffect)(function () {
    if (!onValidityChanged) {
      return;
    }

    onValidityChanged({
      isValid: validationResponse == null,
      errorMessage: validationResponse
    });
  }, [onValidityChanged, validationResponse]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.content)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: (0, _styling.css)(styles.input),
    value: inputValue,
    placeholder: placeholder,
    onChange: onInputChange,
    disabled: disabled || undefined,
    ref: refContainer,
    style: {
      border: validationResponse ? "" : "none"
    },
    type: "number"
  }), incrementStep != null && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.buttonColumn)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.button, incrementDisabled && styles.buttonDisabled),
    onClick: !incrementDisabled ? onUpClicked : undefined
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "chevronRight",
    style: {
      transform: "rotate(270deg)"
    },
    alt: "arrow up",
    className: (0, _styling.css)(styles.arrowImage)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.button, incrementDisabled && styles.buttonDisabled),
    onClick: !decrementDisabled ? onDownClicked : undefined
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "chevronRight",
    style: {
      transform: "rotate(90deg)"
    },
    alt: "arrow down",
    className: (0, _styling.css)(styles.arrowImage)
  })))), validationResponse != null && showValidationStatus && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.errorText)
  }, validationResponse));
};

NumericInput.propDoc = propDoc;
NumericInput.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(NumericInput);

exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref3) {
  var disabled = _ref3.disabled,
      _ref3$borderRadius = _ref3.borderRadius,
      borderRadius = _ref3$borderRadius === void 0 ? 4 : _ref3$borderRadius,
      hideBorder = _ref3.hideBorder,
      isValid = _ref3.isValid;

  var _useDeviceStore = (0, _device.useDeviceStore)(),
      isFirefox = _useDeviceStore.isFirefox;

  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      borderPrimary = _useTheming$theme.borderPrimary,
      surfaceLightest = _useTheming$theme.surfaceLightest,
      surfaceLight = _useTheming$theme.surfaceLight,
      textBlack = _useTheming$theme.textBlack,
      negative = _useTheming$theme.negative,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "column",
        userSelect: "none"
      },
      content: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        border: hideBorder ? undefined : "solid 1px ".concat(isValid ? borderPrimary : negative),
        height: 40,
        borderRadius: borderRadius,
        backgroundColor: disabled ? surfaceLight : surfaceLightest,
        opacity: disabled ? 0.5 : 1,
        overflow: "hidden"
      },
      input: {
        fontSize: 14,
        flex: isFirefox ? "1 1 auto" : 1,
        width: isFirefox ? "0%" : "100%",
        padding: "0px 9px",
        textAlign: "right",
        flexShrink: 0,
        color: textBlack,
        border: "none",
        ":focus": {
          outline: "none",
          borderColor: "none",
          boxShadow: "none"
        },
        ":disabled": {
          backgroundColor: surfaceLight
        },
        margin: 0,
        height: "100%",
        "-moz-appearance": "textfield"
      },
      buttonColumn: {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "column",
        borderLeft: "solid 1px ".concat(isValid ? borderPrimary : negative),
        padding: "2px 0px",
        flexShrink: 0
      },
      button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "50%",
        cursor: disabled ? "default" : "pointer",
        padding: "0px 5px",
        ":hover": {
          backgroundColor: "rgb(249, 249, 249)",
          boxShadow: "0 1px 0 0 rgba(22, 29, 37, 0.1)"
        },
        flexShrink: 0
      },
      arrowImage: {
        width: 12,
        userSelect: "none"
      },
      errorText: {
        fontSize: 12,
        fontFamily: fonts.semibold,
        lineHeight: 1.33,
        color: negative,
        marginTop: 7,
        animationDuration: "300ms",
        cursor: "default"
      },
      buttonDisabled: {
        opacity: 0.3,
        cursor: "default"
      }
    });
  }, [isFirefox, disabled, borderRadius, hideBorder, isValid, borderPrimary, surfaceLightest, surfaceLight, textBlack, negative, fonts.semibold]);
};